import script from "./dryice.vue?vue&type=script&setup=true&lang=js"
export * from "./dryice.vue?vue&type=script&setup=true&lang=js"

import "./dryice.vue?vue&type=style&index=0&id=18742684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18742684"]])

export default __exports__